/*********************** Custom JS for Boost AI Search & Discovery  ************************/
(function () {
if (window.__boostSdCustomScriptLoaded) {
  return;
}
window.__boostSdCustomScriptLoaded = true;

function formRequest(value) {
    return new Promise((resolve, reject) => {
        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open("GET", Shopify.routes.root + 'products/' + value + '?view=boost-sd-integration');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => resolve(xhr.responseText);
        xhr.onerror = () => reject(xhr.statusText);
        xhr.send();
    });
}

const customize = {
    customizeCollectionHeader: (componentRegistry) => {
        componentRegistry.useComponentPlugin('HeaderDescription', {
            name: 'Move Collection Description Below Product List',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        const descriptionElement = element.getRootElm();
                        if (!descriptionElement) return;
                        const descriptionContent = descriptionElement.innerHTML;
                        let hasUpdated = false;

                        if (descriptionElement && descriptionContent.indexOf('<p>-----</p>') !== -1 && !hasUpdated) {
                            hasUpdated = true;
                            // Select product list
                            const productListContainerElement = document.querySelector(".boost-sd__filter-block .boost-sd-container");
                            const splitDescription = descriptionContent.split('<p>-----</p>');
                            descriptionElement.innerHTML = splitDescription[splitDescription.length - 1];
                            if (productListContainerElement) {
                                // Move to below product list
                                let bottomDescription = '<div class="boost-sd_bottom-description">';
                                for (let i = 0; i < splitDescription.length; i++) {
                                    if (i !== splitDescription.length - 1) {
                                        bottomDescription += splitDescription[i];
                                    }
                                }
                                bottomDescription += '</div>';
                                productListContainerElement.insertAdjacentHTML('beforeend', bottomDescription);
                            }
                        }
                    } catch (err) {
                        console.error(err);
                    }
                }
            }),
        });

        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'ProductList - call get Products Data',
            apply() {
                return {
                    async afterRender(element) {
                        let productHandle = '';
                        if (element.getParams().props && element.getParams().props.product) {
                            productHandle = element.getParams().props.product.handle;
                        }

                        let requestReg = formRequest(productHandle);
                        requestReg.then((res_success) => {
                            let res = JSON.parse(res_success);
                            if (typeof Shopify.PaymentButton === 'undefined' && /<\!--.*?-->/.test(res)) {
                                res = res.replace(/<\!--.*?-->/g, '');
                            }

                            let productItems = document.querySelectorAll(`.boost-sd__product-item[data-product-id="` + res.id + `"] `);

                            if (productItems && productItems.length > 0) {
                                for (let productItem of productItems) {
                                    if (productItem.querySelector('.boost-sd__product-item-grid-view-layout-image .product_form') == null) {
                                        productItem.querySelector('.boost-sd__product-item-grid-view-layout-image').insertAdjacentHTML('beforeend', res.quick_add.trim());
                                        $(".add_to_cart").click(function() {

                                            var countTime_addtocart = 0;
                                            var refreshIntervalId_addtocart = setInterval(function() {
                                                ++countTime_addtocart;
                                                if (countTime_addtocart == 12) {
                                                    clearInterval(refreshIntervalId_addtocart);


                                                }
                                                $(".ProPriceMini").load(window.location.href + " .ProPriceMini");
                                            }, 1000);

                                        });


                                        $(".remove-icon").click(function() {
                                            var countTime_removeicon = 0;

                                            var refreshIntervalId_removeicon = setInterval(function() {
                                                ++countTime_removeicon;
                                                if (countTime_removeicon == 12) {
                                                    clearInterval(refreshIntervalId_removeicon);


                                                }
                                                $(".ProPriceMini").load(window.location.href + " .ProPriceMini");
                                            }, 1000);
                                        });

                                        $(".js-change-quantity").click(function() {
                                            var countTime_quantity = 0;
                                            var refreshIntervalId_quantity = setInterval(function() {
                                                ++countTime_quantity;
                                                if (countTime_quantity == 12) {
                                                    clearInterval(refreshIntervalId_quantity);


                                                }
                                                $(".ProPriceMini").load(window.location.href + " .ProPriceMini");
                                            }, 1000);
                                        });
                                        if (!window.__boostSwatchSelectionBound) {
                                            window.__boostSwatchSelectionBound = true;
                                            $(document)
                                                .off('click.boostSwatchSelection', '.swatch-element')
                                                .on('click.boostSwatchSelection', '.swatch-element', function () {
                                                    const swatchValue = $(this).data('value');
                                                    if (!swatchValue) return;
                                                    const escapedSwatchValue = swatchValue.toString().replace(/"/g, '\\"');
                                                    $(this)
                                                        .siblings(`input[value="${escapedSwatchValue}"]`)
                                                        .prop('checked', true)
                                                        .trigger('change');
                                                });
                                        }

                                        /** START Fix add to cart on collection and search pages*/
                                        $(document).on('click', function(e) {
                                            if ($(e.target).closest('.swatch-element').length > 0) {
                                                var value = $(e.target).closest('.swatch-element').attr('data-id');
                                                $(e.target).closest('form').find('.select').find('select').val(value);
                                            }
                                        })
                                        /** END Fix add to cart on collection and search pages*/
                                    }
                                }
                            }
                        }).catch((res_error) => {
                            console.log(res_error)
                        });
                    },
                };
            },
        });

    },

    updateProductItemGrid: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Add extra information',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        // Start customization--------------------------------------------
                        let productData = element.getParams().props.product;
                        let productId = productData.id;
                        if (productData?.split_product) {
                            productId = productData.variant_id;
                        }
                        let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                        /* Start boost 221291 */
                        if (productItem && productData?.percent_sale_min > 0) {
                            productItem.classList.add('boost-sd-on-sale');
                        }
                        if (productItem) {
                            let customTag = productData.tags.filter(e => e.includes("custom:"));
                            if (customTag.length) {
                                let tag_low = customTag[0].replace("custom:", "");
                                let tag_low_lower = customTag[0].replace("custom:", "").toLowerCase().replaceAll(" ", "-").replaceAll("%", "");
                                let customTagHTML = `<a class="boost-sd-custom-tag" href="/collections/${tag_low_lower}"><p class="tag">${tag_low}</p></a>`
                                if (!productItem.querySelector(".boost-sd-custom-tag")) {
                                    productItem.querySelector(".boost-sd__product-info").insertAdjacentHTML("beforeend", customTagHTML)

                                }
                            }
 
                        }
                    }
                    /* End boost 221291 */
                    // End-------------------------------------------------------------
                    catch (e) {
                        console.warn(e);
                    }
                }


            }),
        });
    }
}


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize.customizeCollectionHeader,
    customize.updateProductItemGrid
]);
})();